import { curatedText } from "@softmax/web-features/coworlds";
import type { LeagueSummary } from "@softmax/observatory-client/types";
import { curatedPitch, stripLeagueName } from "@/features/game/media";
import { gameBrief } from "@/lib/leagues/watch/index";
import { sentencesOf } from "../data/preview-text";

export function previewLead({
  league,
  leagueSegment,
  coworldName,
}: {
  readonly league: LeagueSummary;
  readonly leagueSegment: string | undefined;
  readonly coworldName: string;
}): {
  readonly brief: ReturnType<typeof gameBrief>;
  readonly pitch: string | null;
  readonly opening: string;
} {
  const ownSentences = leagueSegment
    ? sentencesOf(league.description?.trim() ?? "")
    : [];
  const [premise, ...remainingSentences] = ownSentences;
  const brief =
    premise !== undefined
      ? { premise, rest: remainingSentences.join(" ") }
      : gameBrief(league);
  const pitch = leagueSegment ? null : curatedPitch(league.name);
  const opening = brief
    ? stripLeagueName({ sentence: brief.premise, name: coworldName })
    : "";
  return { brief, pitch, opening };
}

export function joinSentences({
  opening,
  rest,
}: {
  readonly opening: string;
  readonly rest: string;
}): string {
  const closed = /[.!?]$/.test(opening) ? opening : `${opening}.`;
  return rest ? `${closed} ${rest}` : closed;
}
export function aboutFrom({
  curatedBlurb,
  brief,
  opening,
  blurb,
}: {
  readonly curatedBlurb: string | null;
  readonly brief: {
    readonly premise: string;
    readonly rest: string;
  } | null;
  readonly opening: string;
  readonly blurb: string;
}): {
  body: string;
} | null {
  const full =
    curatedBlurb ??
    (brief && opening
      ? joinSentences({
          opening,
          rest: brief.rest,
        })
      : "");
  const body = curatedText(full);
  return body && body !== blurb ? { body } : null;
}
